module.exports = "/packs/course-web-writing-ce1772eb601619db942c5879aa74ac02.png";